export const assetImageSlots = [
  'container',
  'image',
  'assetIcon',
  'assetCaption',
  'fallbackIcon',
  'fallbackCaption',
];
